import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { useAuth } from './use-auth'
import { rememberAuthRedirect } from '@/services/redirect-store'

export function ProtectedRoute() {
  const { isAuthenticated, isInitializing } = useAuth()
  const location = useLocation()

  if (isInitializing) return <AuthLoadingScreen />
  if (!isAuthenticated) {
    rememberAuthRedirect(`${location.pathname}${location.search}${location.hash}`)
    return <Navigate to="/login" replace />
  }
  return <Outlet />
}

export function AnonymousOnlyRoute() {
  const { isAuthenticated, isInitializing } = useAuth()

  if (isInitializing) return <AuthLoadingScreen />
  if (isAuthenticated) return <Navigate to="/jobs" replace />
  return <Outlet />
}

function AuthLoadingScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-white" role="status">
      <div className="size-9 animate-spin rounded-full border-4 border-primary/15 border-t-primary" />
      <span className="sr-only">Restoring your session</span>
    </div>
  )
}
